import { keep1Decimal, keep2Decimal, keepNumber } from '@assets/js/regExUtil';

export const dialogTablePropertiesKaiBan = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数片数',
    prop: 'base_output_num',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output_num = keepNumber(val)) }
  },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '额外产值',
    prop: 'additional_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 5, input: (val, row) => (row.additional_output = keep2Decimal(val)) }
  },
  {
    label: '片数产值',
    prop: 'number_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 5, input: (val, row) => (row.number_output = keep2Decimal(val)) }
  },
  {
    label: '个数产值',
    prop: 'quantity_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 5, input: (val, row) => (row.quantity_output = keep2Decimal(val)) }
  }
];

export const dialogTablePropertiesYinHua = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '产值单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesZhiKa = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '新款单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  },
  {
    label: '修改单价',
    prop: 'modify_unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.modify_unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesJiGuang = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesDianXiu = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '刺绣单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  },
  {
    label: '贴布单价',
    prop: 'modify_unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.modify_unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesShouCai = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesBeiLiao = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesFuHe = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesJiFeng = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '狗玩具单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  },
  {
    label: '狗衣服单价',
    prop: 'modify_unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.modify_unit_price = keep1Decimal(val)) }
  },
  {
    label: '片数单价',
    prop: 'number_unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 5, input: (val, row) => (row.number_unit_price = keep2Decimal(val)) }
  }
];

export const dialogTablePropertiesShouGong = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];

export const dialogTablePropertiesJianYan = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];
export const dialogTablePropertiesRuKu = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  }
];
export const dialogTablePropertiesBaoJia = [
  { label: '所属打样间', prop: 'belo_dept_name', itemType: 'input', input: false },
  {
    label: '基数产值',
    prop: 'base_output',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 4, input: (val, row) => (row.base_output = keepNumber(val)) }
  },
  {
    label: '片数单价',
    prop: 'unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.unit_price = keep1Decimal(val)) }
  },
  {
    label: '估价单价',
    prop: 'modify_unit_price',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 5, input: (val, row) => (row.modify_unit_price = keep2Decimal(val)) }
  }
];
